import { toast } from "@bleu.builders/ui";
import { assign, fromPromise, setup } from "xstate";

import { client } from "#/utils/api-client";

const createExternalDiagnosisLogic = fromPromise(
  async ({
    input: { data, organizationId },
  }: {
    input: { data: object; organizationId: string };
  }) => {
    const response = await client(`/diagnoses`, {
      // @ts-ignore
      body: data,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    if (!response.success) {
      toast({
        title: "Erro!",
        description: response.errors,
        variant: "destructive",
      });
    }

    return response;
  },
);

export const diagnosisCreationStateMachine = setup({
  actors: { createExternalDiagnosisLogic },
}).createMachine({
  id: "externalDiagnosisCreation",
  initial: "fillingDiagnosisData",
  context: {
    externalUrl: null,
    diagnosisData: null,
    creationError: null,
    organizationId: null,
  },
  states: {
    fillingDiagnosisData: {
      on: {
        SUBMIT_DIAGNOSIS_DATA: "creationInProgress",
      },
    },
    creationInProgress: {
      invoke: {
        src: "createExternalDiagnosisLogic",
        input: (context) => ({
          data: context.event.diagnosisData,
          organizationId: context.event.organizationId,
        }),
        onDone: {
          target: "diagnosisCreated",
          actions: assign({
            externalUrl: ({ event }) => event.output?.external_url,
          }),
        },
        onError: {
          target: "diagnosisCreationError",
          actions: assign({
            creationError: () => "Erro ao criar diagnóstico externo",
          }),
        },
      },
    },
    diagnosisCreationError: {
      /* render error component */
    },
    diagnosisCreated: {
      /* render success message or copy link component */
    },
  },
});
